import type { FC } from 'react'

import { Select } from '@skytech/ui'
import { useQuery } from '@tanstack/react-query'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import { Translation } from '@/app/translations/Translation'
import adminResources from '@/resources/admin'
import { commonQueries } from '@/resources/queries'

export const AdminOverwriteUserId: FC = () => {
  const { data = [], isLoading } = useQuery(commonQueries.adminUsers(), adminResources.getUserList)

  return (
    <Field name="adminOverwriteUserId">
      {({ field, form }: FieldProps) => (
        <Select
          isClearable
          id="adminOverwriteUserId"
          label={<Translation id="Who to notify about a new order" />}
          options={data.map(({ id, name }) => ({ value: id, label: name }))}
          marginBottom={16}
          isLoading={isLoading}
          {...field}
          onChange={option => form.setFieldValue(field.name, option?.value)}
        />
      )}
    </Field>
  )
}
